var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectronTopBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.363,
    height: 128.553,
    viewBox: "0 0 110.363 128.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15790",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15790",
    transform: "translate(0.001 0)",
    opacity: 0.253
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21769",
    "data-name": "\\u30D1\\u30B9 21769",
    d: "M577.741-320.783a55.342,55.342,0,0,0-55.182-55.376,55.341,55.341,0,0,0-55.18,55.376,55.451,55.451,0,0,0,38.337,52.734,33.055,33.055,0,0,0-14.3,18.915,4.236,4.236,0,0,0-.1,1.529h8.55a26.723,26.723,0,0,1,4.446-8.029c4.639-5.741,11.064-8.652,19.1-8.652a24,24,0,0,1,23.552,16.682h8.545a4.251,4.251,0,0,0-.1-1.529A33.037,33.037,0,0,0,540.5-268.413,55.457,55.457,0,0,0,577.741-320.783ZM522.559-274.55a46.189,46.189,0,0,1-46.039-46.233,46.189,46.189,0,0,1,46.039-46.234,46.189,46.189,0,0,1,46.04,46.234A46.189,46.189,0,0,1,522.559-274.55Z",
    transform: "translate(-467.379 376.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21770",
    "data-name": "\\u30D1\\u30B9 21770",
    d: "M563.414-288.209l-29.349-24.949a6.094,6.094,0,0,0-8.591.7,6.094,6.094,0,0,0,.7,8.591l29.349,24.949a6.073,6.073,0,0,0,3.945,1.451,6.08,6.08,0,0,0,4.646-2.148A6.094,6.094,0,0,0,563.414-288.209Z",
    transform: "translate(-489.502 352.121)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronTopBottom);
export default __webpack_public_path__ + "static/media/electronTopBottom.ee8a050b073b6ddee85a309b0ccfbb0e.svg";
export { ForwardRef as ReactComponent };